import React, { useState, useEffect, useContext } from 'react';

import { Layout, Menu } from 'antd';
import { AuthContext } from 'authContext';
import styled from '@emotion/styled/macro';
import { Link, useLocation, matchPath, withRouter } from 'react-router-dom';

import routes from './routes';

const { Sider } = Layout;
const { SubMenu, Item } = Menu;

const MenuWrapper = styled.div`
  .submenu.ant-menu-submenu > .ant-menu {
    background-color: #e7e7e7;
  }

  .submenu.ant-menu-submenu
    ul
    li.menuItem.ant-menu-item.ant-menu-item-only-child {
    font-weight: 400;
  }

  .submenu.ant-menu-submenu > .ant-menu-submenu-title {
    font-weight: 500;
    margin: 0;
    padding: '0 24 12 16';
    border-bottom: 1px solid #e3e3e3;
  }

  ul li.menuItem.ant-menu-item.ant-menu-item-only-child:not(:last-of-type) {
    font-weight: 500;
    margin: 0;
    padding: 0 24 12 16;
    border-bottom: 1px solid #e3e3e3;
  }

  ul li.menuItem.ant-menu-item.ant-menu-item-only-child:last-of-type {
    font-weight: 500;
    margin: 0;
    padding: 0 24 0 16;
  }
`;

const MobileAppSider = ({ onClick }) => {
  const location = useLocation();
  const authContext = useContext(AuthContext);

  const [selectedKey, setSelectedKey] = useState('');
  const [openedKey, setOpenedKey] = useState('');

  const permissions =
    authContext && authContext.user && authContext.user.permissions;

  useEffect(() => {
    for (let i = 0; i < routes.length; i++) {
      const matchedPath = matchPath(location.pathname, {
        path: routes[i].path,
        exact: true,
        strict: false,
      });

      if (matchedPath) {
        setOpenedKey('');
        setSelectedKey(matchedPath);
        return;
      } else if (routes[i].subItems) {
        const matchedRoute = routes[i].subItems.find((item) =>
          matchPath(location.pathname, {
            path: item.path,
            exact: true,
            strict: false,
          })
        );
        if (matchedRoute) {
          setOpenedKey(`${i}`);
          setSelectedKey(matchedRoute);
          return;
        }
      }
      setSelectedKey('');
      setOpenedKey('');
    }
  }, [location]);

  const onOpenChange = async (keys) => {
    setOpenedKey(keys[keys.length - 1]);
  };

  return (
    <Sider width="100vw" style={{ backgroundColor: '#fff' }}>
      <MenuWrapper>
        {' '}
        <Menu
          onClick={onClick}
          mode="inline"
          style={{ backgroundColor: '#F2F2F2', borderRight: 0 }}
          defaultSelectedKeys={['/']}
          selectedKeys={[selectedKey && selectedKey.path]}
          openKeys={[openedKey]}
          onOpenChange={onOpenChange}
        >
          {routes.map((route, index) => {
            const routePermission = route.permission;
            const isRouteAllowed =
              routePermission && permissions
                ? permissions.includes(routePermission)
                : true;

            return !route.subItems ? (
              isRouteAllowed ? (
                <Item className="menuItem" key={route.path}>
                  <Link to={route.path}>
                    <span>{route.name}</span>
                  </Link>
                </Item>
              ) : null
            ) : isRouteAllowed ? (
              <SubMenu className="submenu" key={index} title={route.name}>
                {route.subItems.map((route) => {
                  const routePermission = route.permission;
                  const isRouteAllowed =
                    routePermission && permissions
                      ? permissions.includes(routePermission)
                      : true;
                  return isRouteAllowed ? (
                    <Item className="menuItem" key={route.path}>
                      <Link to={route.path}>
                        <span>{route.name}</span>
                      </Link>
                    </Item>
                  ) : null;
                })}
              </SubMenu>
            ) : null;
          })}
        </Menu>
      </MenuWrapper>
    </Sider>
  );
};

export default withRouter(MobileAppSider);
